import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./App.vue";
import { createHead } from "@vueuse/head";
import { i18n } from "./i18n-setup.js";
import createAppRouter from "./router.js";
import UIService from "@components/ui/UIService.js";
import { useBreakpoints } from "@vueuse/core";
import DarkMode from "@services/theme/DarkMode.js";
import * as Util from "@utils/Util.js";

// Global styles (import here so SSG picks them up)
import "@assets/tailwind.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import.meta.glob(["@assets/images/*.png", "@assets/images/*.ico"], {
  eager: true,
});

export function configureApp(
  app,
  { router, head, registerRouter = true } = {}
) {
  const pinia = createPinia();
  app.use(pinia);
  app.use(i18n);
  if (head) {
    app.use(head);
  }

  app.config.globalProperties.$util = Util;

  const breakpoints = useBreakpoints({
    mobile: 900,
    desktop: Infinity,
  });
  app.provide("breakpoints", breakpoints);
  app.provide("darkMode", DarkMode);

  if (typeof window !== "undefined") {
    app.use(UIService);
  }

  // Router is installed outside to avoid double registration in ViteSSG
  if (router && registerRouter) {
    app.use(router);
  }
}

export function createMyApp() {
  const app = createApp(App);

  const router = createAppRouter();

  const head = createHead();

  configureApp(app, { router, head, registerRouter: true });

  return { app, router, head };
}

export default createMyApp;
